// Curated brand imagery for Padel Gems public site.
// Verified visual mapping (Sep 2026) — do not swap URLs without re-checking content.

const BASE = 'https://customer-assets-gfyr7b9c.emergentagent.net/job_846dc9b2-e4f0-4080-bae3-4057077d66ec/artifacts';

export const PG_IMAGES = {
  // Wide aerial panorama of the complex — sunset, palms, courts, lounge, Jabal Al Qarah.
  // Hero primary image + Tournaments card + About subtle context.
  aerialComplex: `${BASE}/ksv3zrn6_ChatGPT%20Image%20Sep%207%2C%202026%2C%2007_22_14%20PM.png`,

  // Two players rallying on lit court — "PADEL COURT LIFE" & "PLAY CONNECT BELONG" signage.
  // Community banner background + About subtle context.
  courtSigns: `${BASE}/svb4snuh_ChatGPT%20Image%20Sep%207%2C%202026%2C%2007_24_49%20PM.png`,

  // POV close-up: player about to hit with mountain behind — dramatic action.
  // Court Bookings card + Coaching visual.
  playersAction: `${BASE}/aywdsz27_ChatGPT%20Image%20Sep%207%2C%202026%2C%2007_21_071%20PM.png`,

  // Coffee lounge interior — marble table with signature P-logo cup, courts through glass, sunset.
  // About right inset + F&B services card + hero warm wash.
  coffeeLounge: `${BASE}/vz4yo4iv_ChatGPT%20Image%20Sep%207%2C%202026%2C%2007_26_17%20PM.png`,

  // 4-panel lifestyle collage — aerial, action, lounge, gear.
  // Optional background texture for Services section.
  collage: `${BASE}/m6uo3yy5_ChatGPT%20Image%20Sep%207%2C%202026%2C%2007_21_07%20PM.png`,
};

export default PG_IMAGES;
